module.exports = {"TXTWCL_Returns":{"id":"TXTWCL_Returns","defaultMessage":"Gains"},"TXTWCL_n_a":{"id":"TXTWCL_n_a","defaultMessage":"n/d"}}